import axios from 'axios';
import { API_URI } from './../consts';

export const getFilesByRut = (partnerRut) => {
    return axios.get(`${API_URI}search-files?partnerRut=${partnerRut}`);
};


// WEBPACK FOOTER //
// ./frontEnd/covid/permiso-unico-colectivo/services/collectivePermissionService.js